<div class="draft-success-toast" *ngIf="successToastMessage">
  <mat-icon class="toast-check">check_circle</mat-icon>
  <div class="toast-text">
    <div class="toast-title">Success</div>
    <div class="toast-body">{{ successToastMessage }}</div>
  </div>
  <mat-icon class="toast-close" (click)="closeSuccessToast()">close</mat-icon>
</div>

<div *ngIf="isLoading || successToastMessage" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>

<div [class.blur]="isLoading">

  <div class="breadcrumb-bar">
    <div class="breadcrumb">
      <span class="breadcrumb-current">Action Plan</span>
    </div>
  </div>

  <main class="page-content">
    <section class="content-card">

      <div class="header-bar">
        <div class="title-with-filter">
          <h2 class="title">Action Plan</h2>
          <button *ngIf="hasDashboardFilter" class="btn-clear-filter" (click)="clearDashboardFilter()">
            <mat-icon>filter_alt_off</mat-icon> Clear Filter
          </button>
        </div>
        <div class="header-actions">
          <span class="export-text" [class.disabled]="isExporting" (click)="!isExporting && exportVisible()">Export Visible
            <span class="tooltip-container" (click)="$event.stopPropagation()">
              <mat-icon class="icon-info">info_outline</mat-icon>
              <span class="tooltip-text">Exports all rows for the columns currently visible.</span>
            </span>
          </span>
          <button class="btn-outline" (click)="exportAll()" [disabled]="isExporting">
            Export All
            <span class="tooltip-container" (click)="$event.stopPropagation()">
              <mat-icon class="icon-info">info_outline</mat-icon>
              <span class="tooltip-text">Export all action plan records with all available system columns.</span>
            </span>
          </button>
        </div>
      </div>

      <!-- Search bar + Column Selector -->
      <div class="search-bar">
        <input type="text" placeholder="Search Action Plan" [(ngModel)]="searchText" (ngModelChange)="currentPage = 1" />
        <span class="search-icon"><mat-icon>search</mat-icon></span>
        <mat-icon class="filter-icon" (click)="toggleFilterPanel()">filter_alt</mat-icon>

        <!-- Column Selector dropdown -->
        <div class="filter-dropdown" *ngIf="isFilterOpen">
          <div class="filter-header">
            <span>Column Selector</span>
            <a class="clear" (click)="clearAll()">Clear All</a>
            <a class="select" (click)="selectAll()">Select All</a>
            <mat-icon (click)="toggleFilterPanel()">close</mat-icon>
          </div>

          <div class="filter-search">
            <span class="search-icon-column"><mat-icon class="search-column">search</mat-icon></span>
            <input type="text" placeholder="Search" [(ngModel)]="columnSearchText" />
          </div>

          <!-- Section 1: Review Basic Details -->
          <div class="filter-section-group">
            <div class="filter-section-header" (click)="basicExpanded = !basicExpanded">
              <span>Review Basic Details</span>
              <mat-icon>{{ isBasicExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="isBasicExpanded()">
              <label *ngFor="let col of filteredBasicColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" (ngModelChange)="saveFilterState()" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <!-- Section 2: Schedule -->
          <div class="filter-section-group">
            <div class="filter-section-header" (click)="scheduleExpanded = !scheduleExpanded">
              <span>Schedule</span>
              <mat-icon>{{ isScheduleExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="isScheduleExpanded()">
              <label *ngFor="let col of filteredScheduleColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" (ngModelChange)="saveFilterState()" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <!-- Section 3: Review Cycle -->
          <div class="filter-section-group">
            <div class="filter-section-header" (click)="reviewCycleExpanded = !reviewCycleExpanded">
              <span>Review Cycle</span>
              <mat-icon>{{ isReviewCycleExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="isReviewCycleExpanded()">
              <label *ngFor="let col of filteredReviewCycleColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" (ngModelChange)="saveFilterState()" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <!-- Section 4: Action Plan -->
          <div class="filter-section-group">
            <div class="filter-section-header" (click)="actionPlanExpanded = !actionPlanExpanded">
              <span>Action Plan</span>
              <mat-icon>{{ isActionPlanExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="isActionPlanExpanded()">
              <label *ngFor="let col of filteredActionPlanColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" (ngModelChange)="saveFilterState()" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <div class="filter-footer">
            Total Columns: <b>{{ totalColumnCount() }}</b> &nbsp;&nbsp; Visible: <b>{{ visibleColumnCount() }}</b>
          </div>
        </div>
      </div>

      <!-- Grid -->
      <div class="table-container">
        <table class="custom-table">
          <thead>
            <tr>
              <!-- ── Action Plan ── -->
              <th *ngIf="isColumnVisible('actionPlanId')" (click)="sort('actionPlanId')" [class.active]="sortColumn === 'actionPlanId'">
                <span class="th-content">
                  Action Plan ID
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('actionPlanId') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('actionPlanId')" (click)="toggleColumnFilter('actionPlanId', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'actionPlanId' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('actionPlanDescription')" (click)="sort('actionPlanDescription')" [class.active]="sortColumn === 'actionPlanDescription'">
                <span class="th-content">
                  Action Plan Description
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('actionPlanDescription') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('actionPlanDescription')" (click)="toggleColumnFilter('actionPlanDescription', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'actionPlanDescription' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('closedDate')" (click)="sort('closedDate')" [class.active]="sortColumn === 'closedDate'">
                <span class="th-content">
                  Closed Date for Action Plan
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('closedDate') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('closedDate')" (click)="toggleColumnFilter('closedDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'closedDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('internalDependency')" (click)="sort('internalDependency')" [class.active]="sortColumn === 'internalDependency'">
                <span class="th-content">
                  Internal Dependency
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('internalDependency') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('internalDependency')" (click)="toggleColumnFilter('internalDependency', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'internalDependency' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('targetDate')" (click)="sort('targetDate')" [class.active]="sortColumn === 'targetDate'">
                <span class="th-content">
                  Target Date
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('targetDate') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('targetDate')" (click)="toggleColumnFilter('targetDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'targetDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('actionPlanStatus')" (click)="sort('actionPlanStatus')" [class.active]="sortColumn === 'actionPlanStatus'">
                <span class="th-content">
                  Action Plan Status
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('actionPlanStatus') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('actionPlanStatus')" (click)="toggleColumnFilter('actionPlanStatus', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'actionPlanStatus' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('revisedTargetDate')" (click)="sort('revisedTargetDate')" [class.active]="sortColumn === 'revisedTargetDate'">
                <span class="th-content">
                  Revised Target Date
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('revisedTargetDate') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('revisedTargetDate')" (click)="toggleColumnFilter('revisedTargetDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'revisedTargetDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('linkedIssue')" (click)="sort('linkedIssue')" [class.active]="sortColumn === 'linkedIssue'">
                <span class="th-content">
                  Linked Issues
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('linkedIssue') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('linkedIssue')" (click)="toggleColumnFilter('linkedIssue', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'linkedIssue' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('issueDescription')" (click)="sort('issueDescription')" [class.active]="sortColumn === 'issueDescription'">
                <span class="th-content">
                  Issue Description
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('issueDescription') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('issueDescription')" (click)="toggleColumnFilter('issueDescription', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'issueDescription' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('apRcSupervisor')" (click)="sort('apRcSupervisor')" [class.active]="sortColumn === 'apRcSupervisor'">
                <span class="th-content">
                  R&amp;C Supervisor
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('apRcSupervisor') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('apRcSupervisor')" (click)="toggleColumnFilter('apRcSupervisor', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'apRcSupervisor' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('apRcManager')" (click)="sort('apRcManager')" [class.active]="sortColumn === 'apRcManager'">
                <span class="th-content">
                  R&amp;C Manager
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('apRcManager') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('apRcManager')" (click)="toggleColumnFilter('apRcManager', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'apRcManager' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('subscribersNotify')" (click)="sort('subscribersNotify')" [class.active]="sortColumn === 'subscribersNotify'">
                <span class="th-content">
                  Subscribers/Notify
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('subscribersNotify') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('subscribersNotify')" (click)="toggleColumnFilter('subscribersNotify', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'subscribersNotify' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcComments')" (click)="sort('rcComments')" [class.active]="sortColumn === 'rcComments'">
                <span class="th-content">
                  R&amp;C Comments
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('rcComments') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcComments')" (click)="toggleColumnFilter('rcComments', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcComments' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('actionRequiredBy')" (click)="sort('actionRequiredBy')" [class.active]="sortColumn === 'actionRequiredBy'">
                <span class="th-content">
                  Action Required By
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('actionRequiredBy') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('actionRequiredBy')" (click)="toggleColumnFilter('actionRequiredBy', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'actionRequiredBy' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('reviewObjective')" (click)="sort('reviewObjective')" [class.active]="sortColumn === 'reviewObjective'">
                <span class="th-content">
                  Review Objective
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('reviewObjective') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('reviewObjective')" (click)="toggleColumnFilter('reviewObjective', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'reviewObjective' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('recommendation')" (click)="sort('recommendation')" [class.active]="sortColumn === 'recommendation'">
                <span class="th-content">
                  Recommendation
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('recommendation') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('recommendation')" (click)="toggleColumnFilter('recommendation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'recommendation' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('broadIssueCategory')" (click)="sort('broadIssueCategory')" [class.active]="sortColumn === 'broadIssueCategory'">
                <span class="th-content">
                  Broad Issue Category (L1)
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('broadIssueCategory') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('broadIssueCategory')" (click)="toggleColumnFilter('broadIssueCategory', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'broadIssueCategory' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('detailedIssueCategory')" (click)="sort('detailedIssueCategory')" [class.active]="sortColumn === 'detailedIssueCategory'">
                <span class="th-content">
                  Detailed Issue Category (L2)
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('detailedIssueCategory') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('detailedIssueCategory')" (click)="toggleColumnFilter('detailedIssueCategory', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'detailedIssueCategory' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('repLetterConflict')" (click)="sort('repLetterConflict')" [class.active]="sortColumn === 'repLetterConflict'">
                <span class="th-content">
                  RepLetter Conflict
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('repLetterConflict') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('repLetterConflict')" (click)="toggleColumnFilter('repLetterConflict', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'repLetterConflict' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('repLetterQuestionsWithConflict')" (click)="sort('repLetterQuestionsWithConflict')" [class.active]="sortColumn === 'repLetterQuestionsWithConflict'">
                <span class="th-content">
                  RepLetter Questions with Conflict
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('repLetterQuestionsWithConflict') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('repLetterQuestionsWithConflict')" (click)="toggleColumnFilter('repLetterQuestionsWithConflict', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'repLetterQuestionsWithConflict' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('serviceLine')" (click)="sort('serviceLine')" [class.active]="sortColumn === 'serviceLine'">
                <span class="th-content">
                  Accenture Operations Service Line
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('serviceLine') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('serviceLine')" (click)="toggleColumnFilter('serviceLine', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'serviceLine' }"></ng-container>
              </th>

              <!-- ── Review Basic Details ── -->
              <th *ngIf="isColumnVisible('reviewName')" (click)="sort('reviewName')" [class.active]="sortColumn === 'reviewName'">
                <span class="th-content">
                  Review Name
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('reviewName') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('reviewName')" (click)="toggleColumnFilter('reviewName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'reviewName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('currentStatus')" (click)="sort('currentStatus')" [class.active]="sortColumn === 'currentStatus'">
                <span class="th-content">
                  Current Status
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('currentStatus') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('currentStatus')" (click)="toggleColumnFilter('currentStatus', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'currentStatus' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('proposedYear')" (click)="sort('proposedYear')" [class.active]="sortColumn === 'proposedYear'">
                <span class="th-content">
                  Proposed Year
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('proposedYear') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('proposedYear')" (click)="toggleColumnFilter('proposedYear', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'proposedYear' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('masterClientName')" (click)="sort('masterClientName')" [class.active]="sortColumn === 'masterClientName'">
                <span class="th-content">
                  Master Client Name
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('masterClientName') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('masterClientName')" (click)="toggleColumnFilter('masterClientName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'masterClientName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('dntProjectName')" (click)="sort('dntProjectName')" [class.active]="sortColumn === 'dntProjectName'">
                <span class="th-content">
                  D&amp;T Project Name
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('dntProjectName') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('dntProjectName')" (click)="toggleColumnFilter('dntProjectName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'dntProjectName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('contractNumber')" (click)="sort('contractNumber')" [class.active]="sortColumn === 'contractNumber'">
                <span class="th-content">
                  Contract Number
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('contractNumber') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('contractNumber')" (click)="toggleColumnFilter('contractNumber', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'contractNumber' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('additionalContractNumber')" (click)="sort('additionalContractNumber')" [class.active]="sortColumn === 'additionalContractNumber'">
                <span class="th-content">
                  Additional Contract Number
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('additionalContractNumber') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('additionalContractNumber')" (click)="toggleColumnFilter('additionalContractNumber', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'additionalContractNumber' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('marketUnit')" (click)="sort('marketUnit')" [class.active]="sortColumn === 'marketUnit'">
                <span class="th-content">
                  Market Unit
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('marketUnit') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('marketUnit')" (click)="toggleColumnFilter('marketUnit', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'marketUnit' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('customerRelationshipName')" (click)="sort('customerRelationshipName')" [class.active]="sortColumn === 'customerRelationshipName'">
                <span class="th-content">
                  Customer Relationship Name
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('customerRelationshipName') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('customerRelationshipName')" (click)="toggleColumnFilter('customerRelationshipName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'customerRelationshipName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('planName')" (click)="sort('planName')" [class.active]="sortColumn === 'planName'">
                <span class="th-content">
                  Plan Name
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('planName') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('planName')" (click)="toggleColumnFilter('planName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'planName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('qadRecommendation')" (click)="sort('qadRecommendation')" [class.active]="sortColumn === 'qadRecommendation'">
                <span class="th-content">
                  QAD Recommendation (Opp) / QAD Overall Status (Del)
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('qadRecommendation') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('qadRecommendation')" (click)="toggleColumnFilter('qadRecommendation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'qadRecommendation' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('clientQualityCQI')" (click)="sort('clientQualityCQI')" [class.active]="sortColumn === 'clientQualityCQI'">
                <span class="th-content">
                  Client Quality (CQI)
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('clientQualityCQI') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('clientQualityCQI')" (click)="toggleColumnFilter('clientQualityCQI', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'clientQualityCQI' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('clientAccountLead')" (click)="sort('clientAccountLead')" [class.active]="sortColumn === 'clientAccountLead'">
                <span class="th-content">
                  Client Account Lead (GR)
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('clientAccountLead') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('clientAccountLead')" (click)="toggleColumnFilter('clientAccountLead', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'clientAccountLead' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('masterClientID')" (click)="sort('masterClientID')" [class.active]="sortColumn === 'masterClientID'">
                <span class="th-content">
                  Master Client ID
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('masterClientID') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('masterClientID')" (click)="toggleColumnFilter('masterClientID', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'masterClientID' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('deliveryCountry')" (click)="sort('deliveryCountry')" [class.active]="sortColumn === 'deliveryCountry'">
                <span class="th-content">
                  Delivery Country*
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('deliveryCountry') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('deliveryCountry')" (click)="toggleColumnFilter('deliveryCountry', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'deliveryCountry' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('locationsToBeReviewed')" (click)="sort('locationsToBeReviewed')" [class.active]="sortColumn === 'locationsToBeReviewed'">
                <span class="th-content">
                  Locations to be Reviewed*
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('locationsToBeReviewed') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('locationsToBeReviewed')" (click)="toggleColumnFilter('locationsToBeReviewed', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'locationsToBeReviewed' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('isPrimaryLocation')" (click)="sort('isPrimaryLocation')" [class.active]="sortColumn === 'isPrimaryLocation'">
                <span class="th-content">
                  Is it Primary Location (TBD)?
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('isPrimaryLocation') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('isPrimaryLocation')" (click)="toggleColumnFilter('isPrimaryLocation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'isPrimaryLocation' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('quarter')" (click)="sort('quarter')" [class.active]="sortColumn === 'quarter'">
                <span class="th-content">
                  Quarter
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('quarter') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('quarter')" (click)="toggleColumnFilter('quarter', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'quarter' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('proposedMonth')" (click)="sort('proposedMonth')" [class.active]="sortColumn === 'proposedMonth'">
                <span class="th-content">
                  Proposed Month
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('proposedMonth') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('proposedMonth')" (click)="toggleColumnFilter('proposedMonth', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'proposedMonth' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcManager')" (click)="sort('rcManager')" [class.active]="sortColumn === 'rcManager'">
                <span class="th-content">
                  R&amp;C Manager
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('rcManager') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcManager')" (click)="toggleColumnFilter('rcManager', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcManager' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcSupervisor')" (click)="sort('rcSupervisor')" [class.active]="sortColumn === 'rcSupervisor'">
                <span class="th-content">
                  R&amp;C Supervisor
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('rcSupervisor') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcSupervisor')" (click)="toggleColumnFilter('rcSupervisor', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcSupervisor' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcReviewer')" (click)="sort('rcReviewer')" [class.active]="sortColumn === 'rcReviewer'">
                <span class="th-content">
                  R&amp;C Reviewer
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('rcReviewer') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcReviewer')" (click)="toggleColumnFilter('rcReviewer', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcReviewer' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondaryManager')" (click)="sort('secondaryManager')" [class.active]="sortColumn === 'secondaryManager'">
                <span class="th-content">
                  Secondary Manager
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('secondaryManager') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondaryManager')" (click)="toggleColumnFilter('secondaryManager', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondaryManager' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondarySupervisor')" (click)="sort('secondarySupervisor')" [class.active]="sortColumn === 'secondarySupervisor'">
                <span class="th-content">
                  Secondary Supervisor
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('secondarySupervisor') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondarySupervisor')" (click)="toggleColumnFilter('secondarySupervisor', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondarySupervisor' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondaryReviewer')" (click)="sort('secondaryReviewer')" [class.active]="sortColumn === 'secondaryReviewer'">
                <span class="th-content">
                  Secondary Reviewer
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('secondaryReviewer') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondaryReviewer')" (click)="toggleColumnFilter('secondaryReviewer', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondaryReviewer' }"></ng-container>
              </th>

              <!-- ── Schedule ── -->
              <th *ngIf="isColumnVisible('accentureOperationsSL')" (click)="sort('accentureOperationsSL')" [class.active]="sortColumn === 'accentureOperationsSL'">
                <span class="th-content">
                  Accenture Operation Service Line
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('accentureOperationsSL') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('accentureOperationsSL')" (click)="toggleColumnFilter('accentureOperationsSL', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'accentureOperationsSL' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('targetForReportPublications')" (click)="sort('targetForReportPublications')" [class.active]="sortColumn === 'targetForReportPublications'">
                <span class="th-content">
                  Target for Report Publications
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('targetForReportPublications') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('targetForReportPublications')" (click)="toggleColumnFilter('targetForReportPublications', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'targetForReportPublications' }"></ng-container>
              </th>

              <!-- ── Review Cycle ── -->
              <th *ngIf="isColumnVisible('actualPublicationDate')" (click)="sort('actualPublicationDate')" [class.active]="sortColumn === 'actualPublicationDate'">
                <span class="th-content">
                  Actual Publication Date
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('actualPublicationDate') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('actualPublicationDate')" (click)="toggleColumnFilter('actualPublicationDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'actualPublicationDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('overallReportingRating')" (click)="sort('overallReportingRating')" [class.active]="sortColumn === 'overallReportingRating'">
                <span class="th-content">
                  Overall Reporting Rating
                  <span class="material-symbols-outlined arrow-icon">{{ getSortIcon('overallReportingRating') }}</span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('overallReportingRating')" (click)="toggleColumnFilter('overallReportingRating', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'overallReportingRating' }"></ng-container>
              </th>

              <th class="action-col">Action</th>
            </tr>
          </thead>

          <!-- Shared column filter popup template -->
          <ng-template #colFilter let-col="col">
            <div class="col-filter-popup" *ngIf="activeFilterColumn === col" (click)="$event.stopPropagation()">
              <select [(ngModel)]="filters[col].op1">
                <option *ngFor="let op of operators" [value]="op">{{ op }}</option>
              </select>
              <input type="text" [(ngModel)]="filters[col].val1" placeholder="Filter..." />
              <div class="popup-actions">
                <button type="button" class="btn-reset" (click)="resetFilter(col)">Reset</button>
                <button type="button" class="btn-apply" (click)="applyFilter()">Apply</button>
              </div>
            </div>
          </ng-template>

          <tbody>
            <tr *ngIf="filteredData().length === 0">
              <td [attr.colspan]="visibleColumnCount() + 1" class="no-data-message">No Data Found</td>
            </tr>

            <tr *ngFor="let item of filteredData() | slice:(currentPage-1)*pageSize:currentPage*pageSize">
              <!-- Action Plan cells -->
              <td *ngIf="isColumnVisible('actionPlanId')" class="link">{{ displayActionPlanId(item.actionPlanId) }}</td>
              <td *ngIf="isColumnVisible('actionPlanDescription')" class="truncate-cell" (mouseenter)="setTooltipIfTruncated($event, item.actionPlanDescription)"><span class="truncate-text">{{ item.actionPlanDescription }}</span></td>
              <td *ngIf="isColumnVisible('closedDate')">{{ item.closedDate }}</td>
              <td *ngIf="isColumnVisible('internalDependency')">{{ item.internalDependency }}</td>
              <td *ngIf="isColumnVisible('targetDate')">{{ item.targetDate }}</td>
              <td *ngIf="isColumnVisible('actionPlanStatus')">{{ item.actionPlanStatus }}</td>
              <td *ngIf="isColumnVisible('revisedTargetDate')">{{ item.revisedTargetDate }}</td>
              <td *ngIf="isColumnVisible('linkedIssue')" class="truncate-cell" (mouseenter)="setTooltipIfTruncated($event, item.linkedIssue)"><span class="truncate-text">{{ item.linkedIssue }}</span></td>
              <td *ngIf="isColumnVisible('issueDescription')" class="truncate-cell" (mouseenter)="setTooltipIfTruncated($event, item.issueDescription)"><span class="truncate-text">{{ item.issueDescription }}</span></td>
              <td *ngIf="isColumnVisible('apRcSupervisor')">{{ item.apRcSupervisor }}</td>
              <td *ngIf="isColumnVisible('apRcManager')">{{ item.apRcManager }}</td>
              <td *ngIf="isColumnVisible('subscribersNotify')">{{ item.subscribersNotify }}</td>
              <td *ngIf="isColumnVisible('rcComments')">{{ item.rcComments }}</td>
              <td *ngIf="isColumnVisible('actionRequiredBy')">{{ item.actionRequiredBy }}</td>
              <td *ngIf="isColumnVisible('reviewObjective')">{{ item.reviewObjective }}</td>
              <td *ngIf="isColumnVisible('recommendation')">{{ item.recommendation }}</td>
              <td *ngIf="isColumnVisible('broadIssueCategory')">{{ item.broadIssueCategory }}</td>
              <td *ngIf="isColumnVisible('detailedIssueCategory')">{{ item.detailedIssueCategory }}</td>
              <td *ngIf="isColumnVisible('repLetterConflict')">{{ item.repLetterConflict }}</td>
              <td *ngIf="isColumnVisible('repLetterQuestionsWithConflict')">{{ item.repLetterQuestionsWithConflict }}</td>
              <td *ngIf="isColumnVisible('serviceLine')">{{ item.serviceLine }}</td>
              <!-- Review Basic Details cells -->
              <td *ngIf="isColumnVisible('reviewName')">{{ item.reviewName }}</td>
              <td *ngIf="isColumnVisible('currentStatus')">{{ item.currentStatus }}</td>
              <td *ngIf="isColumnVisible('proposedYear')">{{ item.proposedYear }}</td>
              <td *ngIf="isColumnVisible('masterClientName')">{{ item.masterClientName }}</td>
              <td *ngIf="isColumnVisible('dntProjectName')">{{ item.dntProjectName }}</td>
              <td *ngIf="isColumnVisible('contractNumber')">{{ item.contractNumber }}</td>
              <td *ngIf="isColumnVisible('additionalContractNumber')">{{ item.additionalContractNumber }}</td>
              <td *ngIf="isColumnVisible('marketUnit')">{{ item.marketUnit }}</td>
              <td *ngIf="isColumnVisible('customerRelationshipName')">{{ item.customerRelationshipName }}</td>
              <td *ngIf="isColumnVisible('planName')">{{ item.planName }}</td>
              <td *ngIf="isColumnVisible('qadRecommendation')">{{ item.qadRecommendation }}</td>
              <td *ngIf="isColumnVisible('clientQualityCQI')">{{ item.clientQualityCQI }}</td>
              <td *ngIf="isColumnVisible('clientAccountLead')">{{ item.clientAccountLead }}</td>
              <td *ngIf="isColumnVisible('masterClientID')">{{ item.masterClientID }}</td>
              <td *ngIf="isColumnVisible('deliveryCountry')">{{ item.deliveryCountry }}</td>
              <td *ngIf="isColumnVisible('locationsToBeReviewed')">{{ item.locationsToBeReviewed }}</td>
              <td *ngIf="isColumnVisible('isPrimaryLocation')">{{ item.isPrimaryLocation }}</td>
              <td *ngIf="isColumnVisible('quarter')">{{ item.quarter }}</td>
              <td *ngIf="isColumnVisible('proposedMonth')">{{ item.proposedMonth }}</td>
              <td *ngIf="isColumnVisible('rcManager')">{{ item.rcManager }}</td>
              <td *ngIf="isColumnVisible('rcSupervisor')">{{ item.rcSupervisor }}</td>
              <td *ngIf="isColumnVisible('rcReviewer')">{{ item.rcReviewer }}</td>
              <td *ngIf="isColumnVisible('secondaryManager')">{{ item.secondaryManager }}</td>
              <td *ngIf="isColumnVisible('secondarySupervisor')">{{ item.secondarySupervisor }}</td>
              <td *ngIf="isColumnVisible('secondaryReviewer')">{{ item.secondaryReviewer }}</td>
              <!-- Schedule cells -->
              <td *ngIf="isColumnVisible('accentureOperationsSL')">{{ item.accentureOperationsSL }}</td>
              <td *ngIf="isColumnVisible('targetForReportPublications')">{{ item.targetForReportPublications }}</td>
              <!-- Review Cycle cells -->
              <td *ngIf="isColumnVisible('actualPublicationDate')">{{ item.actualPublicationDate }}</td>
              <td *ngIf="isColumnVisible('overallReportingRating')">{{ item.overallReportingRating }}</td>

              <td class="actions action-col">
                <span class="material-symbols-outlined view-icon" title="View" (click)="viewActionPlan(item)">visibility</span>
                <span class="material-symbols-outlined edit-icon" [class.icon-disabled]="!isAdmin && !isAssignedToRow(item)" [title]="isAdmin || isAssignedToRow(item) ? 'Edit' : 'Access is not provided.'" (click)="(isAdmin || isAssignedToRow(item)) && editActionPlan(item)">edit_square</span>
                <span
                  class="material-symbols-outlined delete-icon"
                  [class.icon-disabled]="!isAdmin"
                  [title]="isAdmin ? 'Delete' : 'Only Admin has access to Delete'"
                  (click)="isAdmin && openDeleteModal(item)">delete</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <span>Show</span>
        <select [(ngModel)]="pageSize" (change)="currentPage = 1">
          <option *ngFor="let size of [10, 25, 50]" [value]="size">{{ size }}</option>
        </select>
        <span>Items/page</span>

        <span>Go to page</span>
        <input type="number" [(ngModel)]="goToPageInput" (keyup.enter)="goToPage()" (change)="goToPage()" min="1" [max]="totalPages()" class="goto-input" />

        <button class="arrow" (click)="firstPage()" [disabled]="currentPage === 1">&#171;</button>
        <button class="arrow" (click)="prevPage()" [disabled]="currentPage === 1">&#8249;</button>

        <button *ngFor="let page of totalPagesArray()" [class.active]="page === currentPage" (click)="currentPage = page">
          {{ page }}
        </button>

        <button class="arrow" (click)="nextPage()" [disabled]="currentPage === totalPages()">&#8250;</button>
        <button class="arrow" (click)="lastPage()" [disabled]="currentPage === totalPages()">&#187;</button>
      </div>

    </section>
  </main>
</div>

<!-- Delete Confirmation Modal -->
<div class="delete-modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="delete-modal" (click)="$event.stopPropagation()">
    <h2 class="delete-modal-title">Delete Action Plan</h2>
    <p class="delete-modal-body">Are you sure you want to delete this action plan?</p>
    <div class="delete-modal-actions">
      <button type="button" class="delete-modal-cancel" (click)="closeDeleteModal()">Cancel</button>
      <button type="button" class="delete-modal-confirm" [disabled]="isDeletingActionPlan" (click)="confirmDeleteActionPlan()">Confirm Delete</button>
    </div>
  </div>
</div>
